// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"280e7db6","204":"3aeb024d","815":"69affa41"}[chunkId] + ".chunk.css";
};